import React from 'react';
import { useWorkflow } from '../contexts/WorkflowContext';
import './Sidebar.css';

const Sidebar = () => {
  const {
    workflows,
    currentWorkflowId,
    setCurrentWorkflow,
    createWorkflow
  } = useWorkflow();

  const handleCreateWorkflow = async () => {
    const name = prompt('Enter workflow name:');
    if (name && name.trim()) {
      try {
        await createWorkflow(name.trim());
      } catch (error) {
        console.error('Error creating workflow:', error);
        alert('Failed to create workflow');
      }
    }
  };

  // Handle dragging nodes from sidebar
  const handleDragStart = (e, nodeType, settings = {}) => {
    console.log('Drag started for node type:', nodeType); // Debug log
    
    const nodeData = {
      type: nodeType,
      settings: settings
    };
    
    // Set the drag data
    e.dataTransfer.setData('application/json', JSON.stringify(nodeData));
    e.dataTransfer.effectAllowed = 'copy';
    
    // Add visual feedback
    e.target.style.opacity = '0.5';
    e.target.style.transform = 'scale(0.95)';
    
    console.log('Drag data set:', nodeData); // Debug log
  };

  const handleDragEnd = (e) => {
    console.log('Drag ended'); // Debug log
    
    // Restore visual feedback
    e.target.style.opacity = '1';
    e.target.style.transform = 'scale(1)';
  };

  const nodeTypes = [
    { type: 'text_prompt', label: 'Text Prompt', icon: '📝' },
    { type: 'image_preview', label: 'Image Preview', icon: '🖼️' },
    { type: 'video_preview', label: 'Video Preview', icon: '🎬' },
    { type: 'audio_preview', label: 'Audio Preview', icon: '🎵' }
  ];

  const aiProviders = [
    { type: 'openai_gpt4', label: 'OpenAI GPT-4', icon: '🤖' },
    { type: 'anthropic_claude', label: 'Anthropic Claude', icon: '🧠' },
    { type: 'elevenlabs_tts', label: 'ElevenLabs TTS', icon: '🎤' },
    { type: 'stable_video', label: 'Stable Video', icon: '🎬' },
    { type: 'runway_gen', label: 'Runway Gen', icon: '🎭' },
    { type: 'pika_labs', label: 'Pika Labs', icon: '⚡' }
  ];

  return (
    <div className="sidebar">
      {/* Workflows Section */}
      <div className="sidebar-section">
        <h3><i className="fas fa-project-diagram"></i> Workflows</h3>
        <div className="workflow-list">
          {Object.values(workflows).map(workflow => (
            <div
              key={workflow.id}
              className={`workflow-item ${currentWorkflowId === workflow.id ? 'active' : ''}`}
              onClick={() => setCurrentWorkflow(workflow.id)}
            >
              <span className="workflow-icon">📁</span>
              <span className="workflow-name">{workflow.name}</span>
              <span className={`workflow-status ${workflow.status}`}>
                {workflow.status}
              </span>
            </div>
          ))}
          {Object.keys(workflows).length === 0 && (
            <div className="empty-state">
              <p>No workflows yet</p>
              <button className="btn btn-primary" onClick={handleCreateWorkflow}>
                Create First Workflow
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Input/Output Nodes Section */}
      <div className="sidebar-section">
        <h3><i className="fas fa-arrows-alt-h"></i> Input/Output Nodes</h3>
        <div className="node-list">
          {nodeTypes.map(node => (
            <div
              key={node.type}
              className="node-item"
              draggable={true}
              onDragStart={(e) => handleDragStart(e, node.type)}
              onDragEnd={handleDragEnd}
            >
              <span className="node-icon">{node.icon}</span>
              <span>{node.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* AI Providers Section */}
      <div className="sidebar-section">
        <h3><i className="fas fa-robot"></i> AI Providers</h3>
        <div className="node-list">
          {aiProviders.map(provider => (
            <div
              key={provider.type}
              className="node-item"
              draggable={true}
              onDragStart={(e) => handleDragStart(e, provider.type)}
              onDragEnd={handleDragEnd}
            >
              <span className="node-icon">{provider.icon}</span>
              <span>{provider.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
